import { render, staticRenderFns } from "./WorkflowIndicators.vue?vue&type=template&id=7537b12f&scoped=true"
import script from "./WorkflowIndicators.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowIndicators.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowIndicators.vue?vue&type=style&index=0&id=7537b12f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537b12f",
  null
  
)

export default component.exports